<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="racine">
    <div class="payment-container">
      <div class="header">
        <h4 class="title is-5">{{ $t('errorPage.title') }}</h4>
      </div>
      <div class="content">
        <p>{{ $t('errorPage.message') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ErrorView",
};
</script>
<style scoped>
.racine {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.payment-container {
  max-width: 600px;
  background-color: var(--tally-white);
  border: 1px solid var(--tally-border);
  border-radius: var(--tally-radius-lg);
  padding: var(--tally-space-6);
  box-shadow: var(--tally-shadow-card);
  margin: 0 auto;
}

@media (max-width: 768px) {
  .payment-container {
    border: none;
    box-shadow: none;
  }
}

.header {
  margin-bottom: var(--tally-space-6);
}

.header h4 {
  font-size: var(--tally-text-2xl);
  font-weight: var(--tally-font-semibold);
  color: var(--tally-text-primary);
  margin: 0;
  line-height: 1;
}

.content {
  margin-top: var(--tally-space-4);
}

p {
  font-size: var(--tally-text-base);
  color: var(--tally-text-secondary);
  line-height: var(--tally-leading-relaxed);
  margin: 0;
}
</style>
